module.exports = __webpack_public_path__ + "static/media/brand.72551993.png";